import { authClient, API } from '../index'

export const getClientAppointments = (clientId) => {
  return authClient().get(`${API}/appointment/client/${clientId}`)
}

export const createAppointment = (payload) => {
  return authClient().post(`${API}/appointment`, payload)
}

export const updateAppointment = (id, payload) => {
  return authClient().put(`${API}/appointment/${id}`, payload)
}

export const cancelAppointment = (id) => {
  return authClient().delete(`${API}/appointment/${id}`)
}

export const getTherapistAvailability = (params) => {
  return authClient().get(`${API}/appointment/availability`, { params })
}
